import React from 'react'
import { Popover } from '@mui/material'


function PopupRenderer({ anchorEl, setAnchorEl, anchorOrigin = {
    vertical: "bottom",
    horizontal: "left"
},
    transformOrigin = {
        vertical: 'right',
        horizontal: 'left'
    },
    children,
    className,
}) {
    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;





    return (
        <>
            <style>
                {`.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation8{
            border-radius:10px;
            margin-top:8px
        }
        `}
            </style>

            <Popover
                id={id}
                className={className && className}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
            >
                {children}
            </Popover>
        </>

    )
}

export default PopupRenderer